import { ReactNode } from 'react'
import { Label } from '../../../ui/label'
import { Switch } from '../../../ui/switch'
import TooltipLabel from './TooltipLabel'
import { SetState } from 'src/utils'

type Props = {
  label: string
  labelOn?: string
  labelOff?: string
  value?: boolean
  title?: string
  tooltip?: ReactNode
  setValue?: any
  disabled?: boolean
} & (
  | {
      disabled?: boolean
      setValue: SetState<boolean>
    }
  | {
      disabled: true
      setValue?: undefined
    }
)

const SwitchWithLabel = (props: Props) => {
  const { labelOn = 'Yes', labelOff = 'No' } = props

  return (
    <div className="flex flex-col items-start w-full gap-1 group">
      <div className="mb-1">
        {props.tooltip === undefined ? (
          <Label title={props.title} htmlFor={props.label}>
            {props.label}
          </Label>
        ) : (
          <TooltipLabel label={props.label} tooltip={props.tooltip} />
        )}
      </div>
      <div className="flex gap-3 items-center">
        <Switch
          disabled={props.disabled}
          id={props.label}
          onClickCapture={() => {
            props.setValue?.((prev: any) => !prev)
          }}
          checked={props.value}
        />
        <span className="text-primary-foreground">
          {props.value ? labelOn : labelOff}
        </span>
      </div>
    </div>
  )
}

export default SwitchWithLabel
